import { BNRichText } from "@bn-monorepo/js-packages";
import { BNRichTextProps } from "@bn-monorepo/js-packages/src/Components/BNRichText/BNRichText";

const RichText: ReactFCWithNoJs<BNRichTextProps> = (props) => {
  return <BNRichText {...props}></BNRichText>;
};

RichText.noJsRequired = true;

export default RichText;
